import { render, staticRenderFns } from "./indexzx.vue?vue&type=template&id=60f45403&scoped=true&"
import script from "./indexzx.vue?vue&type=script&lang=js&"
export * from "./indexzx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f45403",
  null
  
)

export default component.exports